import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  triggers = [
    { title: 'Absoluty', file: 'absoluty.mp3' },
    { title: 'Bring Back', file: 'bringback.mp3' },
    { title: 'Can I get an Amen', file: 'caniget.mp3' },
    { title: 'Choices', file: 'choices.mp3' },
    { title: 'Cocorico', file: 'cocorico.mp3' },
    { title: 'Cover Girl', file: 'covergirl.mp3' },
    { title: 'Cucu', file: 'cucu.mp3' },
    { title: 'Do I Have', file: 'doihave.mp3' },
    { title: 'Flazeda', file: 'flazeda.mp3' },
    { title: 'Gentleman', file: 'gentleman.mp3' },
    { title: 'Halleloo', file: 'halleloo.mp3' },
    { title: 'Helohelo', file: 'helohelo.mp3' },
    { title: 'Hiii', file: 'Hiii.mp3' },
    { title: 'I Feel', file: 'ifeel.mp3' },
    { title:  `I'm Sorry My Dear`, file: 'imsorrymydear.mp3' },
    { title: 'Interval 1', file: 'interval1.mp3' },
    { title: 'Interval 2', file: 'interval2.mp3' },
    { title: 'Let The Music', file: 'letthemusic.mp3' },
    { title: 'Not Today Satin', file: 'nottoday.mp3' },
    { title: 'Opening', file: 'opening.mp3' },
    { title: 'Oh pit crew', file: 'opitcrew.mp3' },
    { title: 'Party', file: 'party.mp3' },
    { title: 'Remember', file: 'remember.mp3' },
    { title: 'Sashay', file: 'sashay.mp3' },
    { title: 'Shantay', file: 'shantay.mp3' },
    { title: 'She Done', file: 'shedone.mp3' },
    { title: 'Silence', file: 'silence.mp3' },
    { title: 'The Time Has Come', file: 'thetimeiscoming.mp3' },
    { title: 'Tongue', file: 'tongue.mp3' },
    { title: 'Uh Girl', file: 'uhgirl.mp3' },
    { title: 'You got shemail', file: 'yougotshemail.mp3' },
    { title: 'You safe', file: 'yousafe.mp3' }
  ];

  audioPlayer;

  constructor(public navCtrl: NavController) {}

  play(entry){

    // this.audioPlayer.pause();

    console.log(this.audioPlayer);

    this.audioPlayer = new Audio(`../assets/audio/${entry.file}`);

    this.audioPlayer.play();

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts